<div class="er-page er-tfa">
    <div class="er-page-head">
      <p class="er-eyebrow">Security</p>
      <h1 class="er-page-title">Complete your two-factor authentication</h1>
    </div>

    <div class="er-card er-tfa-card">
      <form [formGroup]="kycForm">
        <div>
            <mat-form-field appearance="outline" class="er-tfa-field">
              <mat-label>Choose device</mat-label>
              <mat-select formControlName="device">
                <mat-option [value]="deviceObj.value" *ngFor="let deviceObj of devices">
                  {{deviceObj.deviceName}}</mat-option>
              </mat-select>
              <mat-error *ngIf="kycForm.hasError('required','device')">
                Device is required
              </mat-error>
            </mat-form-field>
          </div>
        <div>
            <div class="er-tfa-idtype">
               <mat-label>Customer details</mat-label><br>
              <mat-radio-group value="Aadhaar">
                    <mat-radio-button class="example-margin" value="Aadhaar">
                        Aadhaar
                    </mat-radio-button>
                    <mat-radio-button class="example-margin" style="margin-left: 5%;" value="VID">VID
                     </mat-radio-button>

                    </mat-radio-group>

            </div>

          <mat-form-field appearance="outline" class="er-tfa-field">
            <mat-label>Enter Aadhaar number</mat-label>
            <input matInput type='text' (keypress)="numberOnly($event)" maxlength="12" placeholder="Enter Aadhaar Number"
              formControlName="aadharNum" >
            <mat-error *ngIf="kycForm.hasError('required','aadharNum')">
              Aadhaar Number is required
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" class="er-tfa-field">
            <mat-label>Enter mobile number</mat-label>
            <input matInput type="text" maxlength="10" (keypress)="numberOnly($event)" placeholder="Mobile Number"
              formControlName="mobileNum">
            <mat-error *ngIf="kycForm.hasError('required','mobileNum')">
              Mobile Number is required
            </mat-error>
          </mat-form-field>

        </div>
        <button type="button" class="er-btn er-btn--primary" id="submitBtn" (click)="startScan()"> Scan fingerprint &amp; submit
        </button>
      </form>


    </div>
</div>

<ngx-spinner bdColor="rgba(6, 7, 8, 0.88)" size="medium" color="#01DC64" type="ball-clip-rotate" [fullScreen]="true">
    <p style="color: white"> Processing... </p>
</ngx-spinner>
